import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { HttpService } from '@nha/api/shared';
import { UserSessionService } from '@nha/auth';
import { CURRENT_APPLICATION, IPortalLink } from '@nha/api/core';
import { LoggerApiConfiguration } from '../logger-api-configuration.class';
import { ClientException } from '../types/client-exception.type';

@Injectable()
export class ClientExceptionService extends HttpService {
	private _userSessionService = inject(UserSessionService);
	private _currentApplication$ = inject(CURRENT_APPLICATION);

	private _currentApplication: IPortalLink;

	constructor() {
		const config = inject(LoggerApiConfiguration);

		super(config, 'clientexception');

		this._currentApplication$
			.pipe(
				filter((ca) => ca !== null),
				take(1)
			)
			.subscribe((ca) => (this._currentApplication = ca));
	}

	postToSeq(error: Error): Observable<ClientException> {
		/** get username */
		const username: string = this._userSessionService.getUser().username;

		/** create a client exception */
		const clientException: ClientException = new ClientException();
		clientException.moduleName = this._currentApplication?.portalLinkName || '';
		clientException.name = 'Client Error';
		clientException.url = window.location.href;
		clientException.message = error.message;
		clientException.userAgent = navigator.userAgent;
		clientException.username = username || 'N/A';
		clientException.stackTrace = error.stack;

		/** submit the error to seq */
		return this.http.post<ClientException>(this.serviceUrl, clientException);
	}
}
